module.exports = __webpack_public_path__ + "img/results-not-found-bot.ba134e05.svg";